import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order-list" }

import { ref } from 'vue';
  import KitchenOrderCardCompent from './KitchenOrderCardCompent.vue';
  import { OrderDataModel } from '../model/kitchen';

  interface Props {
    orderList: Array<OrderDataModel>;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'KitchenOrderCompent',
  props: {
    orderList: {}
  },
  setup(__props: any) {

  const props = __props;

  const orderList = ref<Array<OrderDataModel>>(props.orderList);

  const handleServeDish = (dishId: string) => {
    // 实现出餐逻辑
    console.log(`出餐菜品ID: ${dishId}`);
  };

  const handleCompleteAll = (orderId: string) => {
    // 实现全部完成逻辑
    console.log(`完成订单ID: ${orderId}`);
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderList.value, (orderData) => {
      return (_openBlock(), _createBlock(KitchenOrderCardCompent, {
        key: orderData.orderId,
        "order-data": orderData,
        onServeDish: handleServeDish,
        onCompleteAll: handleCompleteAll
      }, null, 8, ["order-data"]))
    }), 128))
  ]))
}
}

})